import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

const groupBy = (items: any[], key: string) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {}
  ) as any;

export const selectUserMessages = createSelector(
  [(store: RootState) => store.userShow.messages],
  (data) =>
    groupBy(
      (data || []).map((item) => ({ ...item, createdAtDate: item.createdAtLegible?.date })),
      "createdAtDate"
    )
);
